import { createSlice, PayloadAction } from "redux-starter-kit";

export interface FeedSidebarSlice {
    open: boolean;
    count: number;
}

// Split into pending and active filters.
const initialState: FeedSidebarSlice = { open: false, count: 0 };
const feedSideBar = createSlice({
    slice: "feedSidebar",
    initialState,
    reducers: {
        openSidebar(state): void {
            state.open = true;
        },
        closeSidebar(state): void {
            state.open = false;
        },
        setFilterCount(state, action: PayloadAction<number>): void {
            state.count = action.payload;
        },
    },
});

// Extract the action creators object and the reducer
const { actions, reducer } = feedSideBar;
// Extract and export each action creator by name
export const { openSidebar, closeSidebar, setFilterCount } = actions;
// Export the reducer, either as a default or named export
export default reducer;
